import { Tag, Text } from '@chakra-ui/core'
import { Repeat } from 'lucide-react'
import { isNumber } from 'lodash'
import React from 'react'
import LocaleText from 'components/LocaleText'
import { getFrequency } from 'components/TasksOverview/TaskV2Item/utils'

export const RecurrenceTag = ({
  recurrence_label,
  isSmall = false,
}: {
  recurrence_label?: number
  isSmall?: boolean
}) => {
  if (!isNumber(recurrence_label)) {
    return null
  }
  return (
    <>
      <Tag
        borderRadius={isSmall ? '8px' : '12px'}
        color="black"
        border="1px solid black"
        minH="unset"
        fontSize={isSmall ? '9px' : '11px'}
        minW={isSmall ? '50px' : '60px'}
        w="max-content"
        lineHeight="normal"
        justifyContent="center"
        alignItems="center"
        p={isSmall ? '2px 6px' : '3px 10px'}
        bg="white"
        style={{ columnGap: isSmall ? '3px' : '5px' }}
      >
        <Repeat size={isSmall ? '8px' : '10px'} />
        <Text>
          <LocaleText text={getFrequency(recurrence_label)} />
        </Text>
      </Tag>
    </>
  )
}
